import { DetailsItem as Item } from '@calendly/booking-kit'
import { UserMultipleIcon } from '@calendly/ui/components/icons'

export default ({ items }) => items.length > 1 && (
  <Item>
    <UserMultipleIcon size="large" spacingRight={8} />
    {items.join(', ')}
  </Item>
)
